import React from 'react';
import styled from '@2pulse/responsive';
import { normalize } from '@app/helpers';
import { row, worksansoxford } from '@app/style';
import { useInput } from '@app/hooks/useInput';
import { StyledInputs } from '../styled/form/Inputs';
import { StyledForms } from '../styled/form/Form';
import SvgCheck from '../icons/SvgCheck';

const CheckboxContainer = styled.TouchableOpacity(({ theme }) => ({
  ...row,
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: normalize(76),
  paddingVertical: normalize(8),
  paddingHorizontal: normalize(21),
}));

const CheckboxLabel = styled.Text<{ disabled?: boolean, checked?: boolean }>(({ theme, props }) => ({
  ...worksansoxford,
  fontSize: normalize(18),
  fontWeight: props.checked ? '700' : '500',
  color: props.disabled ? theme.colors.grey : props.checked ? theme.colors.celadonblue : theme.colors.babypowder,
  flexShrink: 1,
  marginRight: normalize(16),
}));

const CheckboxBox = styled.View<{ checked: boolean; disabled?: boolean }>(({ theme, props }) => ({
  width: normalize(24),
  height: normalize(24),
  borderRadius: 5,
  borderWidth: 3,
  borderColor: props.disabled 
    ? theme.colors.satanGray 
    : props.checked 
      ? theme.colors.celadonblue 
      : theme.colors.babypowder,
  backgroundColor: props.checked 
    ? props.disabled 
      ? theme.colors.satanGray 
      : theme.colors.celadonblue 
    : 'transparent',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}));

const CheckboxIconContainer = styled.View({
  width: normalize(16),
  height: normalize(16),
});

export interface CheckboxProps {
  name: string;
  label: string;
  disabled?: boolean;
  showError?: boolean;
}

export const Checkbox = ({ name, label, disabled = false, showError = true }: CheckboxProps) => {
  const { field, error } = useInput(name);

  const handlePress = () => {
    if (!disabled) {
      field.onChange(!field.value);
    }
  };

  return (
    <StyledInputs.Holder>
      {(!!error && showError) && (
        <StyledForms.Error>
          <StyledForms.ErrorLabel>
            {error}
          </StyledForms.ErrorLabel>
        </StyledForms.Error>
      )}
      
      <CheckboxContainer onPress={handlePress} disabled={disabled}>
        <CheckboxLabel disabled={disabled} checked={!!field.value}>
          {label}
        </CheckboxLabel>
        
        <CheckboxBox checked={!!field.value} disabled={disabled}>
          {field.value && (
            <CheckboxIconContainer>
              <SvgCheck color="#FDFFFC" />
            </CheckboxIconContainer>
          )}
        </CheckboxBox>
      </CheckboxContainer>
    </StyledInputs.Holder>
  );
};
